import { axiosClientAdmin } from "@/lib/auth";
import { Comparator, FilterOperator, GetGetCustomerCustomerData, GetGetCustomerCustomerResponse, GetSearchCustomersCustomerData, GetSearchProjectsCustomerData, GetSearchProjectsCustomerResponse, SortOrder } from "../types.gen";
import { UseQueryOptions } from "@tanstack/react-query";
import { SearchInput, SearchInputBase } from "../util/types";

export type FetchCustomerInput = {
  customerId: string;
}

export const fetchCustomer = async (input: FetchCustomerInput) => {
  const pathTpl: GetGetCustomerCustomerData["url"] = "/Customer/{customerId}"
  const path = pathTpl.replace("{customerId}", input.customerId)

  const { data } = await axiosClientAdmin.get<GetGetCustomerCustomerResponse>(path);

  return data.customer
}
export const FetchCustomerQuery = (input: FetchCustomerInput) => {
  return {
    queryKey: ['customer', input],
    queryFn: () => fetchCustomer(input),
  } satisfies UseQueryOptions
}

export type SearchCustomerSitesQueryInput = SearchInputBase & {
  customerId: string;
  query?: string;
  isActive?: boolean;
}

export const searchCustomerSites = async (input: SearchCustomerSitesQueryInput) => {
  const { customerId, query, isActive = true, ...rest } = input
  const pathTpl: GetSearchProjectsCustomerData["url"] = "/Customer/{customerId}/project/search"
  const path = pathTpl.replace("{customerId}", customerId)

  const search = new SearchInput({
    sortBy: 'name',
    sortDir: SortOrder.Ascending,
    ...rest,
  })

  search.add("query", query ?? undefined)

  if (isActive) {
    search.filterFilters.push({
      field: 'isActive',
      action: Comparator.Eq,
      value: 'true',
    })
  }

  if (query != null) {
    search.filterFilterGroups.push({
      operator: FilterOperator.Or,
      filters: [
        {
          field: 'name',
          action: Comparator.ILike,
          value: query,
        }
      ]
    })
  }

  const { data } = await axiosClientAdmin.get<GetSearchProjectsCustomerResponse>(path, {
    params: search.toParams()
  });

  return data
}

export const SearchCustomerSitesQuery = (input: SearchCustomerSitesQueryInput) => {
  return {
    queryKey: ['customer-sites', input],
    queryFn: () => searchCustomerSites(input),
  } satisfies UseQueryOptions
}